import { memo, useCallback } from "react";

import { GridRenderCellParams } from "@mui/x-data-grid";

import { IRecentEventsTableRow } from "../common/events.models";
import FeedbackThumbs from "./FeedbackThumbs";

interface FeedbackThumbsTableContainerProps {
  params: GridRenderCellParams<IRecentEventsTableRow>;
}

const FeedbackThumbsTableContainerComponent = ({
  params,
}: FeedbackThumbsTableContainerProps) => {
  const memoizedThumbUpClick = useCallback((): void => {
    params?.row?.onThumbUpClick && params?.row?.onThumbUpClick(params?.row);
  }, [params?.row]);

  const memoizedThumbsDownClickCallback = useCallback((): void => {
    params?.row?.onThumbsDownClick &&
      params?.row?.onThumbsDownClick(params?.id as string, params?.row);
  }, [params?.id, params?.row]);

  return (
    <FeedbackThumbs
      disabled
      params={params.row}
      onThumbUpClick={memoizedThumbUpClick}
      onThumbsDownClick={memoizedThumbsDownClickCallback}
    />
  );
};

const FeedbackThumbsTableContainer = memo(
  FeedbackThumbsTableContainerComponent
);

export default FeedbackThumbsTableContainer;
